import { Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import GlobalSearch from '../../utility/GlobalSearch/GlobalSearch';
import globalStyles from './../../../assets/styles/global.module.scss';
import { WorkflowContext, WorkflowContextPayload, workflowList } from '../../../context/workflowContext';
import GridViewIcon from '@mui/icons-material/GridView';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import workflowStyle from "../../../assets/styles/componentStyles/workflowStyles/workflowStyle.module.scss";
import noDataFound from "../../../assets/CampaignNoDataFound.png";
import WorkflowTable from './workflowTable';
import WorkflowGridCard from './workflowGridCard';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { getChatbotListNewReponseModel } from '../../../models/axiosModel';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import globalStrenameDocumentyles from "../../../assets/renameDocument.svg"; 
import deleteDoc from "../../../assets/deleteDoc.svg"; 
import copyIcon from "../../../assets/copy.svg";  
import agent from '../../../services/api';
import GlobalPopUp from '../../utility/globalPopUp';
import PauseIcon from '@mui/icons-material/Pause'; 
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseChatbotPopup from './pauseChatbotPopup';
import { getChatbotStatusInfo } from '../flowBuilder/flowBuilderConstants';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

const WorkflowList = () => {

    const { existingWorkFlowList, getExistingWorkflowList, setCurrentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [filteredWorkFlowList, setFilteredWorkFlowList] = useState<getChatbotListNewReponseModel[] | null>(null);
    const [flagGridView, setFlagGridView] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [currentRowIndex, setCurrentRowIndex] = useState<number | string | null>(null);

    const [flagDeleteWorkflowPopup, setFlagDeleteWorkflowPopup] = useState<boolean>(false);
    const [selectedWorkflowData, setSelectedWorkflowData] = useState<getChatbotListNewReponseModel | null>(null);

    const [flagPauseChatbotPopup, setFlagPauseChatbotPopup] = useState<boolean>(false);


    const breakPoints = {
        smallScreen: useMediaQuery('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const checkPauseChatbotDisable = (currentRowIndex: string | number) => { 
        const selectedWorkflow = filteredWorkFlowList?.find((workflow) => workflow.chatbot_id == currentRowIndex);
        if(selectedWorkflow && selectedWorkflow?.chatbot_status?.chatbot_status_name?.toLowerCase() == "active" || selectedWorkflow?.chatbot_status?.chatbot_status_name?.toLowerCase() == "paused"){
            return false;
        }
        return true;
    } 

    const getChatbotStatusForMenu = () => {
        const selectedWorkflow = filteredWorkFlowList?.find((workflow) => workflow.chatbot_id == selectedWorkflowData?.chatbot_id);
        return getChatbotStatusInfo(selectedWorkflow);
    }

    const workflowActionMenuItem = [
        {
            label: getChatbotStatusForMenu().label,
            icon: getChatbotStatusForMenu().icon,
            action: (list: any) => {
                setSelectedWorkflowData(list);
                setFlagPauseChatbotPopup(true);
            }, 
            isDisabled: checkPauseChatbotDisable(currentRowIndex as string | number), 
            // isDisabled: true,
        },
        {
            label: "Delete",
            icon: <img alt="" src={deleteDoc} />,
            action: (list: any) => {
                setSelectedWorkflowData(list);
                setFlagDeleteWorkflowPopup(true)
            }, 
            isDisabled: false
        }
    ]

    const innerHeight = breakPoints.smallScreen ? (window.innerHeight - 185) : breakPoints.flagTabletScreen ? (window.innerHeight - 218) : (window.innerHeight - 208);

    const handleSearch = (e: any) => {
        const query = e?.target?.value?.toLowerCase();
        if (existingWorkFlowList) {
            const filter_data = existingWorkFlowList.filter((list: getChatbotListNewReponseModel) => {
                return (list.chatbot_name != null && list.chatbot_name.toLowerCase().includes(query))
            })
            setFilteredWorkFlowList(filter_data);
        }
    }

    const handleDeleteWorkflow = async () => { 
        if(selectedWorkflowData){
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            const res = await agent.deleteChatbotWorkflow.delete(selectedWorkflowData?.chatbot_id ?? "");
            if(res.status){
                showSuccess(`${selectedWorkflowData?.chatbot_name} deleted successfully.`)
                await getExistingWorkflowList();
            } else {
                handleError(res);
            }  
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }

    useEffect(() => {
        (async () => {
            setFlagLoading((prevState) => {
                return { ...prevState, flagRoundLoader: true }
            });
            await getExistingWorkflowList()
            setCurrentActiveStaticWorkflow(null)
            setFlagLoading((prevState) => {
                return { ...prevState, flagRoundLoader: false }
            });
        })()
    }, [])

    useEffect(() => {
        if (existingWorkFlowList) {
            setFilteredWorkFlowList(existingWorkFlowList)
        }
    }, [existingWorkFlowList])

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>, rowIndex: number | string, list: any) => {
        setCurrentRowIndex(rowIndex);
        setAnchorEl(event.currentTarget);
        setSelectedWorkflowData(list);
    };

    const handleMenuClose = () => {
        setCurrentRowIndex(null);
        setAnchorEl(null);
    };

    return (
        <>
            <Grid container>
                <Grid item xs={12} sm={12} sx={{ padding: "0 17px 0 22px", width: "100%" }}>
                    <Grid container mb={"10px"} mt={"10px"} alignItems={{ xs: "start", sm: "end" }} flexDirection={"column"} gap={"12px"}>
                        <Grid item className={`${globalStyles.globalSearchbarSubItem}`}>
                            <GlobalSearch
                                fullWidth
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleSearch(e) }}
                                size="small"
                                placeholder="Search"
                                sx={{
                                    "& .MuiOutlinedInput-input": {
                                        padding: "8px 2px !important"
                                    },

                                    "& .MuiOutlinedInput-root": {
                                        paddingLeft: "10px !important"
                                    }
                                }}
                            />
                        </Grid>
                        {/* <Grid item>
                            <Grid container className={workflowStyle.viewAsGridContainer} justifyContent={"start"} alignItems={"center"} gap={"5px"} onClick={() => setFlagGridView(prev => !prev)}>
                                <Grid item sx={{ display: "flex" }}>
                                    {flagGridView ?
                                        <FormatListBulletedIcon sx={{ color: "#7a7a7a", height: "20px !important", width: "20px !important" }} />
                                        :
                                        <GridViewIcon sx={{ color: "#7a7a7a", height: "20px !important", width: "20px !important" }} />
                                    }
                                </Grid>
                                <Grid item>
                                    <Typography className={workflowStyle.viewAsGridTypography}>{flagGridView ? "View as List" : "View as Grid"}</Typography>
                                </Grid>
                            </Grid>
                        </Grid> */}
                    </Grid>

                    {!filteredWorkFlowList ?
                        <></> :
                        filteredWorkFlowList.length > 0 ?
                            <Grid item xs={12}>
                                {!flagGridView ?
                                    <WorkflowTable
                                        innerHeight={innerHeight}
                                        filteredWorkFlowList={filteredWorkFlowList}
                                        setFilteredWorkFlowList={setFilteredWorkFlowList}
                                        anchorEl={anchorEl}
                                        setAnchorEl={setAnchorEl}
                                        currentRowIndex={currentRowIndex}
                                        setCurrentRowIndex={setCurrentRowIndex}
                                        handleMenuOpen={handleMenuOpen}
                                        handleMenuClose={handleMenuClose}
                                        setFlagDeleteWorkflowPopup={setFlagDeleteWorkflowPopup} 
                                        workflowActionMenuItem={workflowActionMenuItem}
                                    />
                                    :
                                    <Grid container gap={"18px"} sx={{ padding: "15px 0 5px 5px", maxHeight: `${innerHeight}px !important`, overflow: "auto" }}>
                                        {
                                            filteredWorkFlowList.map((list: getChatbotListNewReponseModel, ind: number) => {
                                                return (
                                                    <Grid item key={ind}>
                                                        <WorkflowGridCard
                                                            list={list}
                                                            anchorEl={anchorEl}
                                                            setAnchorEl={setAnchorEl}
                                                            currentRowIndex={currentRowIndex}
                                                            setCurrentRowIndex={setCurrentRowIndex}
                                                            handleMenuOpen={handleMenuOpen}
                                                            handleMenuClose={handleMenuClose}
                                                            setFlagDeleteWorkflowPopup={setFlagDeleteWorkflowPopup} 
                                                            workflowActionMenuItem={workflowActionMenuItem}
                                                        />
                                                    </Grid>
                                                );
                                            })
                                        }
                                    </Grid>
                                }
                            </Grid>
                            :
                            <Grid item xs={12} className={workflowStyle.noDataFoundItem}>
                                <Grid container sx={{ display: "block", textAlign: "center" }}>
                                    <Grid item>
                                        <img src={noDataFound} alt="" />
                                    </Grid>
                                    <Grid item >
                                        <Typography component={'span'} sx={{ fontSize: "15px", fontWeight: "500" }}>
                                            No Data Found!
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                    }
                </Grid>
                {flagDeleteWorkflowPopup &&
                    <GlobalDeletePopup
                        deleteDescription={`Are you sure want to delete ${selectedWorkflowData?.chatbot_name} chatbot`}
                        open={flagDeleteWorkflowPopup}
                        onClose={() => { setFlagDeleteWorkflowPopup(false); setSelectedWorkflowData(null) }}
                        onDelete={() => {
                            handleDeleteWorkflow()
                            setFlagDeleteWorkflowPopup(false)
                        }}
                    />
                } 
                {flagPauseChatbotPopup && 
                    <GlobalPopUp
                        open={flagPauseChatbotPopup}
                        onClose={() => { setFlagPauseChatbotPopup(false); }}
                        handleClose={() => { setFlagPauseChatbotPopup(false); }}
                        flagShowCloseIcon={true}
                        paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "600px"}
                        paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "700px"}
                        borderRadius='10px'
                        titlePadding='0px'
                        overflow="hidden"
                    >
                        <PauseChatbotPopup
                            setFlagPauseChatbotPopup={setFlagPauseChatbotPopup} 
                            selectedWorkflowData={selectedWorkflowData as getChatbotListNewReponseModel} 
                            getExistingWorkflowList={getExistingWorkflowList}
                        />
                    </GlobalPopUp>   
                }
            </Grid>
        </>
    )
}

export default WorkflowList;